import React from "react";
import s from "./Card.module.scss";
import ArrowRight from "../../../../../../global components/Icons/ArrowRight";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { ArrowDownFilled } from "../../../../../../global components/Icons/ArrowDownFilled";
import { ArrowTop } from "../../../../../../global components/Icons/ArrowTop";
import { Skeleton } from "antd";
type PropType = {
  title: string;
  stat: number;
  rate: string;
  success: boolean;
  isLoading: boolean;
  path: string;
};
function Card({ rate, stat, success, title, isLoading, path }: PropType) {
  return (
    <Link to={path} className={s.link}>
      {isLoading ? (
        <Skeleton active={true} paragraph={{ rows: 2 }} />
      ) : (
        <div className={s.wrapper}>
          <div className={s.cardHead}>
            <h5 className={s.title}>{title}</h5>
            <ArrowRight className={s.icon} />
          </div>
          <div className={s.body}>
            <h6 className={s.label}>{stat.toLocaleString()}</h6>
            <span
              className={clsx(s.stat, {
                [s.success]: success,
                [s.error]: !success,
              })}
            >
              {success ? (
                <ArrowTop className={s.icon} />
              ) : (
                <ArrowDownFilled className={s.icon} />
              )}
              {rate}
            </span>
          </div>
        </div>
      )}
    </Link>
  );
}

export default Card;
